import { Arbor } from "@/pages/catalogs/models/Arbor";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (arbor: Arbor) => void;
	setShowModal: (
		modal:
			| "create"
			| "update"
			| "delete"
			| "deleteMultiple"
			| "confirmRollsetDeactivation"
			| "activeCarrier"
			| "",
	) => void;
};
export const useArborOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Arbor | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Arbor",
				key: "new_arbor",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			const needsRollsetConfirmation =
				data.IsInActiveRollset && !data.IsInActiveCarrier;

			options = options.concat([
				{
					name: "Edit Arbor",
					key: "edit_arbor",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Arbor",
					key: "delete_arbor",
					onClick: () => {
						setSelectedRowData(data);
						if (data.IsInActiveCarrier) {
							setShowModal("activeCarrier");
						} else if (needsRollsetConfirmation) {
							setShowModal("confirmRollsetDeactivation");
						} else {
							setShowModal("delete");
						}
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows?.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_arbors",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Arbor",
					key: "duplicate_arbor",
					onClick: () => {
						setSelectedRowData({
							...data,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
